import { START_CALL } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function startCall(startCallArguments) {
  return callingAPIMethodWithQueue(START_CALL, startCallArguments);
}